export const ENDPOINTS = {
  GET_HISTORICAL_SUMMARY: '/HistoricalData',
  // Confirmed against the live backend's swagger.json: GET/POST at /SourceInfo,
  // PUT at /SourceInfo/{id} (id is an integer — not Code).
  GET_SOURCE_INFO: '/SourceInfo',
  CREATE_SOURCE_INFO: '/SourceInfo',
  UPDATE_SOURCE_INFO: '/SourceInfo',
  // POST /AirlineRefreshConfiguration/Config — the real update path for
  // enabling/disabling + refreshing an airline's source config (confirmed
  // via live swagger.json). This is what SourceInfo's Edit/Save now calls.
  UPDATE_AIRLINE_CONFIGURATION: '/AirlineRefreshConfiguration/Config',
  // GET/POST /StaffDetails, PUT /StaffDetails/{id} — clean REST CRUD for the
  // Staff Details admin page (dbo.AzureAdMenuAccessPermission). Unlike Source
  // Info, there is no separate "Config" endpoint quirk here.
  GET_STAFF_DETAILS: '/StaffDetails',
  CREATE_STAFF_DETAILS: '/StaffDetails',
  UPDATE_STAFF_DETAILS: '/StaffDetails',
  // GET /ApiMetadata/names and /ApiMetadata/calls — backed by the api_name /
  // api_call SQL Server tables, feeding the Logs Insights API Name/API Call
  // dropdowns.
  GET_API_NAMES: '/ApiMetadata/names',
  GET_API_CALLS: '/ApiMetadata/calls',
  // GET /ApiMetadata/check-azure-ad-access?azureAdId=... — checks the caller's
  // Azure AD id/email against AzureAdMenuAccessPermission and returns only
  // { isOwner }; never the underlying table.
  CHECK_AZURE_AD_ACCESS: '/ApiMetadata/check-azure-ad-access',
  // GET /ApiMetadata/menus — active dbo.Menu rows [{ id, menuKey, label }], the
  // options for Staff Details' Menu Access selection.
  GET_MENUS: '/ApiMetadata/menus',
  // GET /ApiMetadata/my-menu-access — { isOwner, menuKeys } for the signed-in
  // user (identified from the access token), used to build the navigation.
  GET_MY_MENU_ACCESS: '/ApiMetadata/my-menu-access',
};
